var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{staticClass:"notification-bell",attrs:{"content":_vm.count,"value":_vm.count > 0,"color":"primary500","bordered":"","overlap":""}},[_c('fai',{staticClass:"text-h5 link grey100--text",attrs:{"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }